export const ADD_MATCHED_REQUEST = 'matches/ADD_MATCHED_REQUEST';
export const ADD_MATCHED_RECORD = 'matches/ADD_MATCHED_RECORD';
export const TOGGLE_NO_MATCH = 'matches/TOGGLE_NO_MATCH';
export const TOGGLE_PRECLEARANCE_NO_MATCH = 'matches/TOGGLE_PRECLEARANCE_NO_MATCH';
export const DELETE_MATCH = 'matches/DELETE_MATCH';
